// @core/api/endpoints/project/complete_sprint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CompleteSprintRequest,
  SprintResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Complete sprint
 * Ends the sprint and calculates final metrics. Incomplete items can optionally be moved to a specified future sprint.
 */
export async function CompleteSprint(
  project_id: string,
  sprint_id: string,
  data: CompleteSprintRequest,
  options?: RequestOptions
): Promise<SprintResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints/:sprint_id/complete`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':sprint_id', encodeURIComponent(sprint_id));
  const requestOptions = options;
  return client.post<SprintResponse>(requestPath, data, requestOptions);
}
